/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import EnrollPlanChoice from './EnrollPlanChoiceContainer'

export default EnrollPlanChoice
